/**
 * 去雾面板相关的常量
 */

// 事件名称
export const DEHAZE_CHANGE_EVENT = 'dehaze-change'
export const CONTROL_EVENT = 'controlEvent'

// CSS 类名常量
export const EMPTY_STATE_MOBILE_CLASS = 'text-center text-white/30 py-8 text-sm'
export const EMPTY_STATE_DESKTOP_CLASS = 'flex flex-col items-center justify-center py-12 text-white/30 gap-4'
export const CONTENT_CONTAINER_MOBILE_CLASS = 'flex flex-col gap-3'
export const CONTENT_CONTAINER_DESKTOP_CLASS = 'flex flex-col gap-3 bg-white/5 rounded-2xl border border-white/5'